import { Grid, SxProps, Theme, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom'
import { gradientsC, IsLeo, themeC } from "../theme/themehelper";
import { FreeBet } from "../models/freebet";
import { Button } from "../reusable-components";

function FreebetListItem({ freebet, theme }: { freebet: FreeBet, theme: string }) {

    const { t } = useTranslation();
    const isSmallScreen = useMediaQuery('(max-width: 620px)');


    if (freebet === undefined) {
        return (<></>);
    }

    let borderWidth = "1px";

    let smallText: SxProps<Theme> = {
        fontSize: "14px",
        color: 'var(--text-black)',
        fontWeight: "400",
        fontFamily: 'var(--font-body)',
        margin: "0px"
    };

    let smallTextValues: SxProps<Theme> = {
        fontSize: "14px",
        color: 'var(--text-black)',
        lineHeight: "21px",
        fontWeight: "400",
        fontFamily: 'var(--font-body)',
    };

    let smallTitleUpper: SxProps<Theme> = {
        fontSize: isSmallScreen ? "16px" : "20px",
        color: 'var(--text-black)',
        fontWeight: "700",
        fontFamily: 'var(--font-title)',
        textTransform: 'uppercase',
        paddingLeft: '20px',
        paddingRight: '10px',
        maxWidth: isSmallScreen ? '200px' : "auto",
        minWidth: isSmallScreen ? '100px' : "auto",
        textWrap: "wrap",
        textAlign: isSmallScreen ? "center" : 'left'
    };

    let button: SxProps<Theme> = {
        marginTop: '10px',
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: '25px',
        paddingRight: '25px',
        gap: '4px',
        color: 'var(--button-text-color)',
        height: '32px',
        textTransform: 'var(--text-transform-button)',
        fontWeight: 'var(--font-weight-button)',
        fontSize: '12px',
        lineHeight: '18px',
        border: borderWidth + ' solid #DADADA',
        borderRadius: '5px',
        backgroundColor: "var(--button-color)",
        "&:hover": {
            backgroundColor: "var(--button-hover-color)",
            border: borderWidth + ' solid #DADADA',
        }
    }

    let border = "";
    let boxShadow = "rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px";


    if (theme === themeC.Kung) {

        smallText = {
            fontSize: "14px",
            lineHeight: "21px",
            color: "#78C4F8",
            fontWeight: "400",
            fontFamily: 'var(--font-title)',
            margin: '8px'
        };

        smallTextValues = {
            fontSize: "14px",
            color: '#FFF',
            lineHeight: "21px",
            fontWeight: "400",
            fontFamily: 'var(--font-body)',
            marginTop: '4px',
            marginBottom: '7px',
        };

        button.border = "none";
    }

    if (theme === themeC.Dbet) {

        smallText = {
            fontSize: "14px",
            lineHeight: "21px",
            color: "#5E5E5E",
            fontWeight: "400",
            fontFamily: 'var(--font-title)',
        };

        smallTextValues = {
            fontSize: "14px",
            color: '#232323',
            lineHeight: "21px",
            fontWeight: "400",
            fontFamily: 'var(--font-body)',
            marginTop: '4px',
            marginBottom: '7px',
        };

        button.border = "none";

    }

    if (theme === themeC.Video) {

        smallText = {
            fontSize: "14px",
            lineHeight: "21px",
            color: "#7E7E7E",
            fontWeight: "400",
            fontFamily: 'var(--font-title)',
        };

        smallTextValues = {
            fontSize: "14px",
            color: '#FFF',
            lineHeight: "21px",
            fontWeight: "400",
            fontFamily: 'var(--font-body)',
            marginTop: '4px',
            marginBottom: '7px',
        };
    }

    if (theme === themeC.MrVegas) {

        smallText = {
            fontSize: "14px",
            lineHeight: "21px",
            color: "#8AD798",
            fontWeight: "400",
            fontFamily: 'var(--font-title)',
            margin: '8px'
        };

        smallTextValues = {
            fontSize: "14px",
            color: '#FFF',
            lineHeight: "21px",
            fontWeight: "400",
            fontFamily: 'var(--font-body)',
            marginTop: '4px',
            marginBottom: '7px',
        };

        button.border = "none";
    }

    let gradient = "";

    if (theme === themeC.Orange) {
        gradient = gradientsC.Orange.Flex;
        boxShadow = "0px 1px 3px 0px #00000040";
        border = "";
    }

    if (theme === themeC.GoGo) {
        gradient = gradientsC.GoGo.Flex;
        boxShadow = "0px 1px 3px 0px #00000040";
        border = "";
    }

    if (theme === themeC.Wood) {
        gradient = gradientsC.Wood.Flex;
        boxShadow = "0px 1px 3px 0px #00000040";
        border = "";
    }

    if (theme === themeC.Lion) {
        gradient = gradientsC.Lion.Flex;
        boxShadow = "0px 1px 3px 0px #00000040";
        border = "";
    }

    if (theme === themeC.Green) {
        gradient = gradientsC.Green.Flex;
        boxShadow = "0px 1px 3px 0px #00000040";
        border = "";
    }

    if (theme === themeC.ComeOn) {
        gradient = gradientsC.ComeOn.Flex;
        boxShadow = "0px 1px 3px 0px #00000040";
        smallTitleUpper.fontFamily = 'Gravity';
        border = "";
    }

    return (
        <Grid container flexWrap="nowrap" direction='row' alignItems="center" component={Link} to={`/freebet/${freebet.id}`} sx={{
            width: isSmallScreen ? "296px" : "90%",
            border: border,
            borderRadius: 'var(--radius)',
            background: 'var(--list-boxes-primary)',
            backgroundOrigin: "border-box",
            backgroundClip: "padding-box, border-box",
            margin: "10px",

            textDecoration: 'none',
            boxShadow: boxShadow
        }}>
            {/*             <Grid container direction='column' sx={{
                width: "120px",
                backgroundImage: gradient,
                height: "100%",
                backgroundSize: "cover",
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: "var(--radius)"

            }}>
                <Grid item sx={{
                    width: "100px",
                    backgroundSize: 'cover',
                    marginLeft: "0px",
                    marginRight: "0px",
                }}>

                    {IsLeo(window.theme) &&
                        <Grid direction="column" container alignItems="center" sx={{

                        }}>
                            <Typography sx={{
                                fontSize: theme === themeC.ComeOn ? '16px' : "16px",
                                fontFamily: theme === themeC.ComeOn ? 'Gravity' : 'var(--font-title)',
                                color: 'var(--text-white)',
                                fontWeight: "400",
                                textTransform: "uppercase",
                            }}>
                                {t('freebet')}
                            </Typography>
                        </Grid>
                    }
                </Grid>
            </Grid> */}

            <Grid container direction="column" alignItems="center" justifyContent="center" padding="20px" flexGrow={1}>

                <Grid container sx={{ maxWidth: "250px" }} direction='column' alignItems="center" justifyContent='center'>
                    <Typography sx={smallTitleUpper}>{freebet.name}</Typography>
                </Grid>



                <Grid container direction="row" justifyContent="center" alignItems="center" paddingTop="10px">
                    <Button
                        type="button"
                        padding="12px 30px"


                    >
                        {t('pay_freebet')}
                    </Button>
                </Grid>

            </Grid>
        </Grid>
    );

}

export default FreebetListItem;